import axios from 'axios';

import { useAuthStore } from '../store/auth';

export const inferBaseUrl = () => {
  if (process.env.VUE_APP_API_BASE_URL) {
    return process.env.VUE_APP_API_BASE_URL;
  }

  if (typeof window !== 'undefined') {
    const { origin, hostname } = window.location;
    if (hostname === 'roterfaden.linkebonn.de') {
      return 'https://api.roterfaden.linkebonn.de';
    }
        if (hostname === 'dev.roterfaden.linkebonn.de') {
      return 'https://dev.api.roterfaden.linkebonn.de';
    }
    if (origin.startsWith('http')) {
      if (/:\d+$/.test(origin)) {
        return origin.replace(/:\d+$/, ':8000');
      }
      return `${origin}:8000`;
    }
    return 'http://localhost:8000';
  }

  return 'http://localhost:8000';
};

const api = axios.create({
  baseURL: inferBaseUrl(),
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const auth = useAuthStore();
  if (auth.token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${auth.token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const auth = useAuthStore();
    if (error.response?.status === 401) {
      auth.logout();
    }
    return Promise.reject(error);
  },
);

export default api;
